import { getPaginatedVersions } from '../../../api/versionApi'
import VersionFilter from '../../../components/versions/version-filter/version-filter'
import VersionsList from '../../../components/versions/versions-list/versions-list'
import { getSearchParams, getSearchValues } from '../../../helpers/utils'
import { PageInfo } from '../../../share-types'
import { IPaginatedVersionsParams, IVersion, IVersionFilterParams } from '../share-type'
import { Card, Space } from 'antd'
import { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'

const defaultPageInfo: PageInfo = {
  pageSize: 20,
  currentPage: 1,
  count: 0,
}

const Versions = () => {
  const [searchParams, setSearchParams] = useSearchParams()
  const [versions, setVersions] = useState<IVersion[]>([])
  const [pageInfo, setPageInfo] = useState<PageInfo>(defaultPageInfo)
  const [searchValues, setSearchValues] = useState<IVersionFilterParams>()

  const loadVersions = (params: IPaginatedVersionsParams) => {
    getPaginatedVersions(params).then(response => {
      setVersions(response.data)
      setPageInfo({ ...response.pageInfo, currentPage: response.pageInfo.currentPage + 1 })
    })
  }

  useEffect(() => {
    const values = getSearchValues(
      [
        { key: 'itemType', isBoolean: false },
        { key: 'itemId', isBoolean: false },
        { key: 'eventName', isBoolean: false },
        { key: 'createdAtFrom', isBoolean: false },
        { key: 'createdAtTo', isBoolean: false },
        { key: 'size', isBoolean: false, default: defaultPageInfo.pageSize },
        { key: 'page', isBoolean: false, default: defaultPageInfo.currentPage - 1 },
      ],
      searchParams,
    )
    const data = {
      ...values,
      itemId: values.itemId ? Number(values.itemId) : undefined,
      size: Number(values.size),
      page: Number(values.page),
    }
    setSearchValues(data)
    loadVersions(data)
  }, [])

  const onPaginationChange = (page: number, pageSize: number) => {
    const currentPage = page - 1
    const data = {
      ...searchValues,
      size: pageSize,
      page: currentPage,
    }
    setSearchParams(getSearchParams(data))
    loadVersions(data)
  }

  const onSearch = (value: IVersionFilterParams) => {
    const data = {
      ...value,
      size: pageInfo.pageSize,
      page: 0,
    }
    setSearchValues(value)
    setSearchParams(getSearchParams(data))
    loadVersions(data)
  }

  return (
    <Card>
      <Space orientation="vertical" size="middle" style={{ width: '100%' }}>
        <VersionFilter onSearch={onSearch} formData={searchValues} />
        <VersionsList
          versions={versions}
          getVersionUrl={version => `/versions/${version.id}`}
          showItem
          pagination={{
            current: pageInfo.currentPage,
            pageSize: pageInfo.pageSize,
            total: pageInfo.count,
            showSizeChanger: true,
          }}
          onPaginationChange={onPaginationChange}
        />
      </Space>
    </Card>
  )
}

export default Versions
